"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesforceUserToJSON = exports.SalesforceUserFromJSONTyped = exports.SalesforceUserFromJSON = exports.instanceOfSalesforceUser = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SalesforceUser interface.
 */
function instanceOfSalesforceUser(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSalesforceUser = instanceOfSalesforceUser;
function SalesforceUserFromJSON(json) {
    return SalesforceUserFromJSONTyped(json, false);
}
exports.SalesforceUserFromJSON = SalesforceUserFromJSON;
function SalesforceUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
    };
}
exports.SalesforceUserFromJSONTyped = SalesforceUserFromJSONTyped;
function SalesforceUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'email': value.email,
    };
}
exports.SalesforceUserToJSON = SalesforceUserToJSON;
